import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { SEO } from '../components/SEO';

export const CookiePolicyPage = () => {
  return (
    <main className="min-h-screen pt-32 pb-20" data-testid="cookie-policy-page">
      <SEO title="Cookie tájékoztató" description="Az Akadémia weboldal cookie (süti) tájékoztatója. Milyen sütiket használunk és miért." path="/cookie-tajekoztato" />
      <div className="container-custom">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="max-w-4xl mx-auto"
        >
          <h1 className="font-heading text-4xl md:text-5xl font-semibold text-white mb-8">
            Cookie (süti) tájékoztató
          </h1>

          <div className="glass-card p-8 md:p-12 space-y-12 text-white/70 leading-relaxed">

            {/* I. Mi az a cookie? */}
            <section>
              <h2 className="font-heading text-2xl font-semibold text-white mb-6">
                I. Mi az a cookie (süti)?
              </h2>
              <p className="mb-3">
                A cookie (süti) egy kis méretű szöveges fájl, amelyet a weboldal az Ön böngészőjében helyez el, amikor meglátogatja az oldalt. A cookie-k lehetővé teszik, hogy a weboldal felismerje az Ön böngészőjét, és bizonyos információkat tároljon a beállításairól.
              </p>
              <p className="mb-3">
                A cookie-k két fő típusba sorolhatók:
              </p>
              <ul className="list-disc list-inside space-y-2 ml-4">
                <li>
                  <strong className="text-white">Munkamenet (session) cookie-k:</strong> Ideiglenesen tárolódnak, és a böngésző bezárásakor automatikusan törlődnek.
                </li>
                <li>
                  <strong className="text-white">Állandó (persistent) cookie-k:</strong> A böngészőben maradnak egy meghatározott ideig vagy amíg Ön manuálisan nem törli őket.
                </li>
              </ul>
            </section>

            {/* II. Az Adatkezelő */}
            <section>
              <h2 className="font-heading text-2xl font-semibold text-white mb-6">
                II. Az Adatkezelő
              </h2>
              <div className="grid md:grid-cols-2 gap-4">
                <div>
                  <p className="text-white/80 font-medium">Név:</p>
                  <p className="text-white font-semibold">Akadémia Plusz 2.0 Kft.</p>
                </div>
                <div>
                  <p className="text-white/80 font-medium">Székhely:</p>
                  <p className="text-white font-semibold">1027 Budapest, Kapás utca 6–12</p>
                </div>
                <div>
                  <p className="text-white/80 font-medium">E-mail:</p>
                  <p>
                    <a href="mailto:akademia@dh.hu" className="text-[#56999B] hover:text-[#C4DB72] transition-colors font-semibold">
                      akademia@dh.hu
                    </a>
                  </p>
                </div>
                <div>
                  <p className="text-white/80 font-medium">Telefon:</p>
                  <p>
                    <a href="tel:+36705188091" className="text-[#56999B] hover:text-[#C4DB72] transition-colors font-semibold">
                      +36 70 518 8091
                    </a>
                  </p>
                </div>
              </div>
              <p className="mt-4">
                A személyes adatok kezelésével kapcsolatos részletes tájékoztatásért kérjük, olvassa el{' '}
                <Link to="/adatvedelem" className="text-[#56999B] hover:text-[#C4DB72] transition-colors font-medium">
                  Adatkezelési tájékoztatónkat
                </Link>.
              </p>
            </section>

            {/* III. Milyen cookie-kat használunk? */}
            <section>
              <h2 className="font-heading text-2xl font-semibold text-white mb-6">
                III. Milyen cookie-kat használunk?
              </h2>

              <h3 className="font-heading text-lg font-semibold text-white mb-4">
                a) Feltétlenül szükséges (funkcionális) cookie-k
              </h3>
              <p className="mb-4">
                Ezek a cookie-k a weboldal alapvető működéséhez szükségesek. Nélkülük a weboldal nem tudna megfelelően működni. Ezekhez a cookie-khoz nem szükséges az Ön hozzájárulása.
              </p>

              <div className="overflow-x-auto mb-6">
                <table className="w-full text-sm">
                  <thead>
                    <tr className="border-b border-white/20">
                      <th className="text-left text-white font-semibold py-3 pr-4">Cookie neve</th>
                      <th className="text-left text-white font-semibold py-3 pr-4">Célja</th>
                      <th className="text-left text-white font-semibold py-3 pr-4">Megőrzési idő</th>
                      <th className="text-left text-white font-semibold py-3">Jogalap</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr className="border-b border-white/10">
                      <td className="py-3 pr-4 text-white font-medium">cookieConsent</td>
                      <td className="py-3 pr-4">A felhasználó cookie-beállításainak tárolása</td>
                      <td className="py-3 pr-4">1 év</td>
                      <td className="py-3">Jogos érdek (GDPR 6. cikk (1) f))</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <h3 className="font-heading text-lg font-semibold text-white mb-4">
                b) Harmadik fél által elhelyezett cookie-k (Google Maps)
              </h3>
              <p className="mb-4">
                Weboldalunkon a kapcsolat szekción belül <strong className="text-white">Google Maps térképszolgáltatás</strong> működik, amelyet a Google Ireland Limited (Gordon House, Barrow Street, Dublin 4, Írország) üzemeltet. A Google Maps beágyazása során a Google harmadik félként cookie-kat helyezhet el az Ön böngészőjében.
              </p>

              <div className="overflow-x-auto mb-4">
                <table className="w-full text-sm">
                  <thead>
                    <tr className="border-b border-white/20">
                      <th className="text-left text-white font-semibold py-3 pr-4">Cookie neve</th>
                      <th className="text-left text-white font-semibold py-3 pr-4">Célja</th>
                      <th className="text-left text-white font-semibold py-3 pr-4">Megőrzési idő</th>
                      <th className="text-left text-white font-semibold py-3">Szolgáltató</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr className="border-b border-white/10">
                      <td className="py-3 pr-4 text-white font-medium">NID</td>
                      <td className="py-3 pr-4">A Google által használt egyedi azonosító a beállítások és információk tárolására</td>
                      <td className="py-3 pr-4">6 hónap</td>
                      <td className="py-3">Google</td>
                    </tr>
                    <tr className="border-b border-white/10">
                      <td className="py-3 pr-4 text-white font-medium">CONSENT</td>
                      <td className="py-3 pr-4">A felhasználó Google-szolgáltatásokra vonatkozó cookie-hozzájárulásának tárolása</td>
                      <td className="py-3 pr-4">2 év</td>
                      <td className="py-3">Google</td>
                    </tr>
                    <tr className="border-b border-white/10">
                      <td className="py-3 pr-4 text-white font-medium">__Secure-ENID</td>
                      <td className="py-3 pr-4">Hirdetési beállítások és biztonsági célok</td>
                      <td className="py-3 pr-4">1 év</td>
                      <td className="py-3">Google</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <p className="mb-3">
                A Google Maps használatával összefüggő adatkezelésre a Google saját adatvédelmi irányelvei vonatkoznak:{' '}
                <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer" className="text-[#56999B] hover:text-[#C4DB72] transition-colors">
                  https://policies.google.com/privacy
                </a>
              </p>
              <p>
                A Google cookie-kkal kapcsolatos további információk:{' '}
                <a href="https://policies.google.com/technologies/cookies" target="_blank" rel="noopener noreferrer" className="text-[#56999B] hover:text-[#C4DB72] transition-colors">
                  https://policies.google.com/technologies/cookies
                </a>
              </p>

              <h3 className="font-heading text-lg font-semibold text-white mb-4 mt-8">
                c) Statisztikai és analitikai cookie-k
              </h3>
              <p className="mb-4">
                Weboldalunk a <strong className="text-white">Google Analytics 4 (GA4)</strong> szolgáltatást használja a <strong className="text-white">Google Tag Manager (GTM)</strong> rendszeren keresztül a látogatói forgalom és felhasználói viselkedés elemzésére. Ezeket a cookie-kat <strong className="text-white">kizárólag az Ön előzetes hozzájárulásával</strong> aktiváljuk (Consent Mode v2).
              </p>

              <div className="overflow-x-auto mb-4">
                <table className="w-full text-sm">
                  <thead>
                    <tr className="border-b border-white/20">
                      <th className="text-left text-white font-semibold py-3 pr-4">Cookie neve</th>
                      <th className="text-left text-white font-semibold py-3 pr-4">Célja</th>
                      <th className="text-left text-white font-semibold py-3 pr-4">Megőrzési idő</th>
                      <th className="text-left text-white font-semibold py-3">Szolgáltató</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr className="border-b border-white/10">
                      <td className="py-3 pr-4 text-white font-medium">_ga</td>
                      <td className="py-3 pr-4">Egyedi látogatóazonosító a látogatások megkülönböztetésére</td>
                      <td className="py-3 pr-4">2 év</td>
                      <td className="py-3">Google</td>
                    </tr>
                    <tr className="border-b border-white/10">
                      <td className="py-3 pr-4 text-white font-medium">_ga_*</td>
                      <td className="py-3 pr-4">GA4 munkamenet-adatok tárolása</td>
                      <td className="py-3 pr-4">2 év</td>
                      <td className="py-3">Google</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <p>
                Amennyiben Ön a cookie-hozzájárulási sávon az „Elutasítom" gombot választja, a fenti analitikai cookie-k <strong className="text-white">nem kerülnek elhelyezésre</strong> a böngészőjében. A hozzájárulást bármikor visszavonhatja a böngészője cookie-beállításaiban.
              </p>
            </section>

            {/* IV. A cookie-k jogalapja */}
            <section>
              <h2 className="font-heading text-2xl font-semibold text-white mb-6">
                IV. A cookie-k jogalapja
              </h2>
              <ul className="list-disc list-inside space-y-3 ml-4">
                <li>
                  <strong className="text-white">Feltétlenül szükséges cookie-k:</strong> A GDPR 6. cikk (1) bekezdés f) pontja szerinti jogos érdek. Az ePrivacy irányelv 5. cikk (3) bekezdése alapján ezekhez a cookie-khoz nem szükséges hozzájárulás, mivel kizárólag a weboldal működéséhez szükségesek.
                </li>
                <li>
                  <strong className="text-white">Statisztikai és marketing cookie-k (jövőbeli):</strong> A GDPR 6. cikk (1) bekezdés a) pontja szerinti hozzájárulás alapján kerülnek alkalmazásra. Ezeket kizárólag az Ön előzetes, önkéntes és tájékozott hozzájárulásával használjuk.
                </li>
              </ul>
            </section>

            {/* V. Cookie-k kezelése és törlése */}
            <section>
              <h2 className="font-heading text-2xl font-semibold text-white mb-6">
                V. Cookie-k kezelése és törlése
              </h2>
              <p className="mb-4">
                Ön bármikor módosíthatja vagy visszavonhatja a cookie-beállításait a böngészője beállításaiban. Az alábbiakban összefoglaljuk a leggyakoribb böngészők cookie-kezelési útmutatóit:
              </p>
              <ul className="space-y-3 ml-4">
                <li>
                  <strong className="text-white">Google Chrome:</strong> Beállítások → Adatvédelem és biztonság → Cookie-k és egyéb webhelyadatok
                </li>
                <li>
                  <strong className="text-white">Mozilla Firefox:</strong> Beállítások → Adatvédelem és biztonság → Cookie-k és webhelyadatok
                </li>
                <li>
                  <strong className="text-white">Safari:</strong> Beállítások → Adatvédelem → Cookie-k kezelése
                </li>
                <li>
                  <strong className="text-white">Microsoft Edge:</strong> Beállítások → Cookie-k és webhelyengedélyek → Cookie-k és webhelyadatok kezelése és törlése
                </li>
              </ul>
              <p className="mt-4">
                Felhívjuk figyelmét, hogy a cookie-k letiltása esetén a weboldal egyes funkciói nem működnek megfelelően.
              </p>
            </section>

            {/* VI. A tájékoztató módosítása */}
            <section>
              <h2 className="font-heading text-2xl font-semibold text-white mb-6">
                VI. A tájékoztató módosítása
              </h2>
              <p className="mb-3">
                Az Adatkezelő fenntartja a jogot a jelen tájékoztató egyoldalú módosítására. A módosított tájékoztatót a weboldalon tesszük közzé.
              </p>
              <p>
                Utolsó frissítés: <strong className="text-white">2026. április 16.</strong>
              </p>
            </section>

            {/* VII. Kapcsolat és jogorvoslat */}
            <section>
              <h2 className="font-heading text-2xl font-semibold text-white mb-6">
                VII. Kapcsolat és jogorvoslat
              </h2>
              <p className="mb-4">
                Amennyiben kérdése vagy észrevétele van a cookie-k használatával kapcsolatban, kérjük, vegye fel velünk a kapcsolatot:
              </p>
              <div className="grid md:grid-cols-2 gap-4 mb-6">
                <div>
                  <p className="text-white/80 font-medium">E-mail:</p>
                  <p>
                    <a href="mailto:akademia@dh.hu" className="text-[#56999B] hover:text-[#C4DB72] transition-colors font-semibold">
                      akademia@dh.hu
                    </a>
                  </p>
                </div>
                <div>
                  <p className="text-white/80 font-medium">Telefon:</p>
                  <p>
                    <a href="tel:+36705188091" className="text-[#56999B] hover:text-[#C4DB72] transition-colors font-semibold">
                      +36 70 518 8091
                    </a>
                  </p>
                </div>
              </div>

              <p className="mb-3">
                Ha úgy ítéli meg, hogy a személyes adatai kezelésével kapcsolatban jogsérelem érte, panaszt nyújthat be a Nemzeti Adatvédelmi és Információszabadság Hatóságnál (NAIH):
              </p>
              <div className="bg-white/5 border border-white/10 p-4">
                <p className="text-white font-semibold mb-2">Nemzeti Adatvédelmi és Információszabadság Hatóság</p>
                <p>Cím: 1055 Budapest, Falk Miksa utca 9–11.</p>
                <p>Telefon: +36 (1) 391-1400</p>
                <p>
                  E-mail:{' '}
                  <a href="mailto:ugyfelszolgalat@naih.hu" className="text-[#56999B] hover:text-[#C4DB72] transition-colors">
                    ugyfelszolgalat@naih.hu
                  </a>
                </p>
                <p>
                  Weboldal:{' '}
                  <a href="https://www.naih.hu" target="_blank" rel="noopener noreferrer" className="text-[#56999B] hover:text-[#C4DB72] transition-colors">
                    www.naih.hu
                  </a>
                </p>
              </div>
            </section>

          </div>
        </motion.div>
      </div>
    </main>
  );
};

export default CookiePolicyPage;
